import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APIClient } from "../helpers/api_helper";

const Navdata = () => {
    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isApps, setIsApps] = useState<boolean>(false);
    const [isAuth, setIsAuth] = useState<boolean>(false);
    const [isPages, setIsPages] = useState<boolean>(false);
    const [isBaseUi, setIsBaseUi] = useState<boolean>(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState<boolean>(false);
    const [isForms, setIsForms] = useState<boolean>(false);
    const [isTables, setIsTables] = useState<boolean>(false);
    const [isCharts, setIsCharts] = useState<boolean>(false);
    const [isIcons, setIsIcons] = useState<boolean>(false);
    const [isMaps, setIsMaps] = useState<boolean>(false);
    const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);

    // Apps
    const [isCalendar, setCalendar] = useState<boolean>(false);
    const [isEmail, setEmail] = useState<boolean>(false);
    const [isSubEmail, setSubEmail] = useState<boolean>(false);
    const [isEcommerce, setIsEcommerce] = useState<boolean>(false);
    const [isProjects, setIsProjects] = useState<boolean>(false);
    const [isTasks, setIsTasks] = useState<boolean>(false);
    const [isCRM, setIsCRM] = useState<boolean>(false);
    const [isCrypto, setIsCrypto] = useState<boolean>(false);
    const [isInvoices, setIsInvoices] = useState<boolean>(false);
    const [isSupportTickets, setIsSupportTickets] = useState<boolean>(false);
    const [isNFTMarketplace, setIsNFTMarketplace] = useState<boolean>(false);
    const [isJobs, setIsJobs] = useState<boolean>(false);
    const [isJobList, setIsJobList] = useState<boolean>(false);
    const [isCandidateList, setIsCandidateList] = useState<boolean>(false);


    // Authentication
    const [isSignIn, setIsSignIn] = useState<boolean>(false);
    const [isSignUp, setIsSignUp] = useState<boolean>(false);
    const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);
    const [isPasswordCreate, setIsPasswordCreate] = useState<boolean>(false);
    const [isLockScreen, setIsLockScreen] = useState<boolean>(false);
    const [isLogout, setIsLogout] = useState<boolean>(false);
    const [isSuccessMessage, setIsSuccessMessage] = useState<boolean>(false);
    const [isVerification, setIsVerification] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    // Pages
    const [isProfile, setIsProfile] = useState<boolean>(false);
    const [isLanding, setIsLanding] = useState<boolean>(false);
    const [isBlog, setIsBlog] = useState<boolean>(false);

    // Charts
    const [isApex, setIsApex] = useState<boolean>(false);

    // Multi Level
    const [isLevel1, setIsLevel1] = useState<boolean>(false);
    const [isLevel2, setIsLevel2] = useState<boolean>(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');
    const [projectLinks, setProjectLinks] = useState<Array<{ id: string; label: string; link?: string }>>([]);
    const [isLoadingProjects, setIsLoadingProjects] = useState<boolean>(false);
    const [projectMenuStates, setProjectMenuStates] = useState<{[key: string]: boolean}>({});
    const apiClient = useMemo(() => new APIClient(), []);
    const formattedProjectLinks = useMemo(() => {
        return projectLinks.map((project, index) => ({
            id: project.id || `project-${index}`,
            label: project.label || `Project ${index + 1}`,
            link: project.link || `/apps-projects-overview/${project.id || index}`,
        }));
    }, [projectLinks]);
    const projectMenuItems = useMemo(() => {
        return formattedProjectLinks.map((project) => ({
            id: `project-nav-${project.id}`,
            label: project.label,
            icon: "ri-folder-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                const projectStateKey = `project-${project.id}`;
                setProjectMenuStates(prev => ({
                    ...prev,
                    [projectStateKey]: !prev[projectStateKey]
                }));
            },
            stateVariables: projectMenuStates[`project-${project.id}`] || false,
            subItems: [
                {
                    id: `endpoints-${project.id}`,
                    label: "Endpoints",
                    link: `/projects/${project.id}/endpoints`,
                    parentId: `project-nav-${project.id}`,
                },
                {
                    id: `jobs-${project.id}`,
                    label: "Jobs",
                    link: `/projects/${project.id}/jobs`,
                    parentId: `project-nav-${project.id}`,
                },
                {
                    id: `api-keys-${project.id}`,
                    label: "API Keys",
                    link: `/projects/${project.id}/api-keys`,
                    parentId: `project-nav-${project.id}`,
                }
            ]
        }));
    }, [formattedProjectLinks, projectMenuStates]);

    function updateIconSidebar(e : any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul : any = document.getElementById("two-column-menu");
            const iconItems : any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item:any) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
        if (iscurrentState !== 'Landing') {
            setIsLanding(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const fetchProjects = async () => {
        setIsLoadingProjects(true);
        try {
            const response = await apiClient.get('/project');
            const list = Array.isArray(response?.data ? response.data : response)
                ? (response?.data || response)
                : [];
            const normalized = list.map((project: any, index: number) => ({
                id: project?.id?.toString() || project?.projectId?.toString() || `project-${index}`,
                label: project?.name || project?.projectName || `Project ${index + 1}`,
                link: project?.link || (project?.id ? `/apps-projects-overview/${project.id}` : undefined),
            }));
            setProjectLinks(normalized);
            
            // Initialize project menu states (all collapsed by default)
            const initialStates: {[key: string]: boolean} = {};
            normalized.forEach((project: { id: string; label: string; link?: string }) => {
                initialStates[`project-${project.id}`] = false;
            });
            setProjectMenuStates(initialStates);
        } catch (error) {
            console.error('Failed to fetch projects', error);
            setProjectLinks([]);
            setProjectMenuStates({});
        } finally {
            setIsLoadingProjects(false);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, [apiClient]);

    const expandFirstProject = () => {
        if (formattedProjectLinks.length > 0) {
            const firstProjectId = formattedProjectLinks[0].id;
            setProjectMenuStates(prev => ({
                ...prev,
                [`project-${firstProjectId}`]: true
            }));
        }
    };

    // Expose function globally for onboarding tour
    useEffect(() => {
        (window as any).expandFirstProjectMenu = expandFirstProject;
        return () => {
            delete (window as any).expandFirstProjectMenu;
        };
    }, [formattedProjectLinks]);

    const menuItems : any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
            click: function (e : any) {
                e.preventDefault();
                setIscurrentState('Dashboard');
            },
        },
        {
            label: "Projects",
            isHeader: true,
            actionId: "open-projects-modal",
            actionIcon: "ri-settings-3-line",
        },
        ...projectMenuItems,
        {
            label: "Settings",
            isHeader: true,
        },
        {
            id: "user-profile",
            label: "User Profile",
            icon: "ri-user-line",
            link: "/profile",
        },
        {
            id: "company-profile",
            label: "Company Profile",
            icon: "ri-building-line",
            link: "/company-profile",
        },
        {
            id: "billing",
            label: "Billing",
            icon: "ri-bill-line",
            link: "/billing",
        },
        {
            id: "api-token",
            label: "API Token",
            icon: "ri-key-line",
            link: "/api-token",
        },
        {
            id: "team-management",
            label: "Team Management",
            icon: "ri-team-line",
            link: "/team-management",
        },
        {
            id: "contact-us",
            label: "Contact Us",
            icon: "ri-customer-service-2-line",
            link: "/contact-us",
        },
    ];
    return {
        menuItems: <React.Fragment>{menuItems}</React.Fragment>,
        refreshProjects: fetchProjects
    };
};
export default Navdata;
